import React from "react";

type IconProps = {
  height?: string | number;
  width?: string | number;
  className?: string;
};

export function SearchIcon({ height, width, className }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      width={"18" || width}
      height={"18" || height}
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M15.75 15.75L11.25 11.25M12.75 7.5C12.75 10.3995 10.3995 12.75 7.5 12.75C4.60051 12.75 2.25 10.3995 2.25 7.5C2.25 4.60051 4.60051 2.25 7.5 2.25C10.3995 2.25 12.75 4.60051 12.75 7.5Z'
        stroke='#6E7C87'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
export function CustomIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='4' height='16' viewBox='0 0 4 16' fill='none'>
      <path
        d='M1.98043 4.00005C1.58874 4.00005 1.20584 3.88265 0.880153 3.66289C0.554471 3.44313 0.300618 3.13088 0.150722 2.76543C0.000827294 2.39998 -0.0383506 1.99787 0.0380653 1.60991C0.114481 1.22195 0.303106 0.865446 0.580077 0.585741C0.857047 0.306036 1.20988 0.115549 1.59405 0.0383781C1.97822 -0.0387923 2.37645 0.00101653 2.73833 0.152392C3.10021 0.303767 3.40952 0.560066 3.62714 0.888964C3.84475 1.21786 3.96088 1.60449 3.96088 2.00005C3.96088 2.53048 3.7522 3.03928 3.38079 3.41435C3.00939 3.78943 2.50568 4.00005 1.98043 4.00005ZM1.98043 10C1.58874 10 1.20584 9.88265 0.880153 9.66289C0.554471 9.44313 0.300618 9.13088 0.150722 8.76543C0.000827294 8.39998 -0.0383506 7.99787 0.0380653 7.60991C0.114481 7.22195 0.303106 6.86545 0.580077 6.58574C0.857047 6.30604 1.20988 6.11555 1.59405 6.03838C1.97822 5.96121 2.37645 6.00102 2.73833 6.15239C3.10021 6.30377 3.40952 6.56007 3.62714 6.88896C3.84475 7.21786 3.96088 7.60449 3.96088 8.00005C3.96088 8.53048 3.7522 9.03928 3.38079 9.41435C3.00939 9.78943 2.50568 10 1.98043 10ZM1.98043 16C1.58874 16 1.20584 15.8827 0.880153 15.6629C0.554471 15.4431 0.300618 15.1309 0.150722 14.7654C0.000827294 14.4 -0.0383506 13.9979 0.0380653 13.6099C0.114481 13.2219 0.303106 12.8654 0.580077 12.5857C0.857047 12.306 1.20988 12.1155 1.59405 12.0384C1.97822 11.9612 2.37645 12.001 2.73833 12.1524C3.10021 12.3038 3.40952 12.5601 3.62714 12.889C3.84475 13.2179 3.96088 13.6045 3.96088 14C3.96088 14.5305 3.7522 15.0393 3.38079 15.4144C3.00939 15.7894 2.50568 16 1.98043 16Z'
        fill='#909AB0'
      />
    </svg>
  );
}

export function PersonIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M7.49997 6C7.49997 4.80653 7.97408 3.66193 8.81799 2.81802C9.66191 1.97411 10.8065 1.5 12 1.5C13.1934 1.5 14.338 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6C16.5 7.19347 16.0259 8.33807 15.182 9.18198C14.338 10.0259 13.1934 10.5 12 10.5C10.8065 10.5 9.66191 10.0259 8.81799 9.18198C7.97408 8.33807 7.49997 7.19347 7.49997 6ZM3.75097 20.105C3.78469 17.9395 4.66862 15.8741 6.21193 14.3546C7.75525 12.8351 9.83419 11.9834 12 11.9834C14.1658 11.9834 16.2447 12.8351 17.788 14.3546C19.3313 15.8741 20.2153 17.9395 20.249 20.105C20.2516 20.2508 20.2116 20.3942 20.134 20.5176C20.0564 20.641 19.9445 20.7392 19.812 20.8C17.3611 21.9237 14.6961 22.5037 12 22.5C9.21397 22.5 6.56697 21.892 4.18797 20.8C4.05546 20.7392 3.94355 20.641 3.86594 20.5176C3.78832 20.3942 3.74837 20.2508 3.75097 20.105Z'
        fill='#A8A8A8'
      />
    </svg>
  );
}
export function PhoneIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M1.5 4.5C1.5 3.70435 1.81607 2.94129 2.37868 2.37868C2.94129 1.81607 3.70435 1.5 4.5 1.5H5.872C6.732 1.5 7.482 2.086 7.691 2.92L8.796 7.343C8.88554 7.701 8.86746 8.07746 8.74401 8.42522C8.62055 8.77299 8.39723 9.07659 8.102 9.298L6.809 10.268C6.674 10.369 6.645 10.517 6.683 10.62C7.24738 12.1549 8.1386 13.5487 9.29495 14.7051C10.4513 15.8614 11.8451 16.7526 13.38 17.317C13.483 17.355 13.63 17.326 13.732 17.191L14.702 15.898C14.9234 15.6028 15.227 15.3794 15.5748 15.256C15.9225 15.1325 16.299 15.1145 16.657 15.204L21.08 16.309C21.914 16.518 22.5 17.268 22.5 18.129V19.5C22.5 20.2956 22.1839 21.0587 21.6213 21.6213C21.0587 22.1839 20.2956 22.5 19.5 22.5H17.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z'
        fill='#A8A8A8'
      />
    </svg>
  );
}
export function EmailIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M1.5 8.67001V17.25C1.5 18.0457 1.81607 18.8087 2.37868 19.3713C2.94129 19.9339 3.70435 20.25 4.5 20.25H19.5C20.2956 20.25 21.0587 19.9339 21.6213 19.3713C22.1839 18.8087 22.5 18.0457 22.5 17.25V8.67001L13.572 14.163C13.0992 14.4539 12.5551 14.6079 12 14.6079C11.4449 14.6079 10.9008 14.4539 10.428 14.163L1.5 8.67001Z'
        fill='#A8A8A8'
      />
      <path
        d='M22.5 6.908V6.75C22.5 5.95435 22.1839 5.19129 21.6213 4.62868C21.0587 4.06607 20.2956 3.75 19.5 3.75H4.5C3.70435 3.75 2.94129 4.06607 2.37868 4.62868C1.81607 5.19129 1.5 5.95435 1.5 6.75V6.908L11.214 12.886C11.4504 13.0314 11.7225 13.1084 12 13.1084C12.2775 13.1084 12.5496 13.0314 12.786 12.886L22.5 6.908Z'
        fill='#A8A8A8'
      />
    </svg>
  );
}
export function LocationIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        d='M15 4.6875H9C8.85082 4.6875 8.70774 4.74676 8.60225 4.85225C8.49676 4.95774 8.4375 5.10082 8.4375 5.25V14.8125H10.6875V12C10.6875 11.8508 10.7468 11.7077 10.8523 11.6023C10.9577 11.4968 11.1008 11.4375 11.25 11.4375H12.75C12.8992 11.4375 13.0423 11.4968 13.1477 11.6023C13.2532 11.7077 13.3125 11.8508 13.3125 12V14.8125H15.5625V5.25C15.5625 5.10082 15.5032 4.95774 15.3977 4.85225C15.2923 4.74676 15.1492 4.6875 15 4.6875ZM10.3125 9.75C10.3125 9.89918 10.2532 10.0423 10.1477 10.1477C10.0423 10.2532 9.89918 10.3125 9.75 10.3125C9.60082 10.3125 9.45774 10.2532 9.35225 10.1477C9.24676 10.0423 9.1875 9.89918 9.1875 9.75V9C9.1875 8.85082 9.24676 8.70774 9.35225 8.60225C9.45774 8.49676 9.60082 8.4375 9.75 8.4375C9.89918 8.4375 10.0423 8.49676 10.1477 8.60225C10.2532 8.70774 10.3125 8.85082 10.3125 9V9.75ZM10.3125 6.75C10.3125 6.89918 10.2532 7.04226 10.1477 7.14775C10.0423 7.25324 9.89918 7.3125 9.75 7.3125C9.60082 7.3125 9.45774 7.25324 9.35225 7.14775C9.24676 7.04226 9.1875 6.89918 9.1875 6.75V6C9.1875 5.85082 9.24676 5.70774 9.35225 5.60225C9.45774 5.49676 9.60082 5.4375 9.75 5.4375C9.89918 5.4375 10.0423 5.49676 10.1477 5.60225C10.2532 5.70774 10.3125 5.85082 10.3125 6V6.75ZM12.5625 9.75C12.5625 9.89918 12.5032 10.0423 12.3977 10.1477C12.2923 10.2532 12.1492 10.3125 12 10.3125C11.8508 10.3125 11.7077 10.2532 11.6023 10.1477C11.4968 10.0423 11.4375 9.89918 11.4375 9.75V9C11.4375 8.85082 11.4968 8.70774 11.6023 8.60225C11.7077 8.49676 11.8508 8.4375 12 8.4375C12.1492 8.4375 12.2923 8.49676 12.3977 8.60225C12.5032 8.70774 12.5625 8.85082 12.5625 9V9.75ZM12.5625 6.75C12.5625 6.89918 12.5032 7.04226 12.3977 7.14775C12.2923 7.25324 12.1492 7.3125 12 7.3125C11.8508 7.3125 11.7077 7.25324 11.6023 7.14775C11.4968 7.04226 11.4375 6.89918 11.4375 6.75V6C11.4375 5.85082 11.4968 5.70774 11.6023 5.60225C11.7077 5.49676 11.8508 5.4375 12 5.4375C12.1492 5.4375 12.2923 5.49676 12.3977 5.60225C12.5032 5.70774 12.5625 5.85082 12.5625 6V6.75ZM14.8125 9.75C14.8125 9.89918 14.7532 10.0423 14.6477 10.1477C14.5423 10.2532 14.3992 10.3125 14.25 10.3125C14.1008 10.3125 13.9577 10.2532 13.8523 10.1477C13.7468 10.0423 13.6875 9.89918 13.6875 9.75V9C13.6875 8.85082 13.7468 8.70774 13.8523 8.60225C13.9577 8.49676 14.1008 8.4375 14.25 8.4375C14.3992 8.4375 14.5423 8.49676 14.6477 8.60225C14.7532 8.70774 14.8125 8.85082 14.8125 9V9.75ZM14.8125 6.75C14.8125 6.89918 14.7532 7.04226 14.6477 7.14775C14.5423 7.25324 14.3992 7.3125 14.25 7.3125C14.1008 7.3125 13.9577 7.25324 13.8523 7.14775C13.7468 7.04226 13.6875 6.89918 13.6875 6.75V6C13.6875 5.85082 13.7468 5.70774 13.8523 5.60225C13.9577 5.49676 14.1008 5.4375 14.25 5.4375C14.3992 5.4375 14.5423 5.49676 14.6477 5.60225C14.7532 5.70774 14.8125 5.85082 14.8125 6V6.75Z'
        fill='#A8A8A8'
      />
      <path
        d='M12 0.1875C6.72722 0.1875 2.4375 4.47722 2.4375 9.75C2.4375 11.383 2.93288 13.1398 3.90994 14.9719C4.67733 16.4107 5.74373 17.9023 7.07958 19.4051C9.3412 21.9493 11.5688 23.6297 11.6625 23.7C11.7599 23.773 11.8783 23.8125 12 23.8125C12.1217 23.8125 12.2401 23.773 12.3375 23.7C12.4313 23.6297 14.6588 21.9493 16.9204 19.405C18.2564 17.9021 19.3227 16.4106 20.0901 14.9717C21.0671 13.1398 21.5625 11.383 21.5625 9.75C21.5625 4.47722 17.2728 0.1875 12 0.1875ZM12 17.25C10.9597 17.2504 9.93066 17.0339 8.97873 16.6142C8.0268 16.1945 7.17287 15.5808 6.47147 14.8125H7.875V9.9375H4.50239C4.50083 9.875 4.50003 9.8125 4.5 9.75C4.5 5.6145 7.8645 2.25 12 2.25C16.1355 2.25 19.5 5.6145 19.5 9.75C19.5 9.81266 19.4992 9.87516 19.4976 9.9375H16.125V14.8125H17.5285C16.8271 15.5808 15.9732 16.1945 15.0213 16.6142C14.0693 17.0339 13.0403 17.2504 12 17.25Z'
        fill='#A8A8A8'
      />
    </svg>
  );
}
export function OrganizationIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M11.6719 0.914062C11.6719 0.827038 11.7064 0.743578 11.768 0.682043C11.8295 0.620508 11.913 0.585938 12 0.585938C12.087 0.585938 12.1705 0.620508 12.232 0.682043C12.2936 0.743578 12.3281 0.827038 12.3281 0.914062V3.06642H13.4122C13.5413 3.06642 13.6465 3.1717 13.6465 3.3008V4.0628H10.33V3.3008C10.33 3.1717 10.4353 3.06642 10.5644 3.06642H11.6719V0.914062ZM8.03053 22.1682C8.03053 23.8294 2.01483 23.8294 2.01483 22.1682C2.01483 20.5071 3.36164 19.1605 5.0228 19.1605C6.68391 19.1605 8.03053 20.5071 8.03053 22.1682ZM15.0078 22.1682C15.0078 23.8294 8.99213 23.8294 8.99213 22.1682C8.99213 20.5071 10.3389 19.1605 12.0001 19.1605C13.6612 19.1605 15.0078 20.5071 15.0078 22.1682ZM10.6099 16.9691C10.6099 17.7369 11.2323 18.3593 12.0001 18.3593C12.7679 18.3593 13.3903 17.7369 13.3903 16.9691C13.3903 16.2015 12.7679 15.5791 12.0001 15.5791C11.2323 15.5791 10.6099 16.2015 10.6099 16.9691ZM21.9852 22.1404C21.9852 23.8015 15.9695 23.8015 15.9695 22.1404C15.9695 20.4793 17.3163 19.1326 18.9775 19.1326C20.6386 19.1326 21.9852 20.4793 21.9852 22.1404ZM17.5873 16.9413C17.5873 17.7091 18.2096 18.3315 18.9775 18.3315C19.7453 18.3315 20.3677 17.7091 20.3677 16.9413C20.3677 16.1737 19.7453 15.5513 18.9775 15.5513C18.2096 15.5513 17.5873 16.1737 17.5873 16.9413ZM3.63258 16.9691C3.63258 17.7369 4.25494 18.3593 5.0228 18.3593C5.79066 18.3593 6.41297 17.7369 6.41297 16.9691C6.41297 16.2015 5.79061 15.5791 5.0228 15.5791C4.25498 15.5791 3.63258 16.2015 3.63258 16.9691ZM15.806 4.719H8.19403C8.13191 4.71912 8.07237 4.74386 8.02844 4.78778C7.98451 4.83171 7.95978 4.89125 7.95966 4.95337V19.9774C8.2012 20.3004 8.38762 20.6612 8.51133 21.045C8.87175 19.9251 9.75666 19.0403 10.8766 18.6797C10.3207 18.3138 9.95367 17.6842 9.95367 16.9691C9.95367 15.8392 10.8702 14.9229 12.0001 14.9229C13.13 14.9229 14.0465 15.8392 14.0465 16.9691C14.0465 17.6842 13.6795 18.3138 13.1236 18.6797C14.2389 19.0387 15.121 19.9178 15.4842 21.0312C15.6079 20.6422 15.7958 20.2766 16.0403 19.9497V4.95337C16.0403 4.82428 15.9351 4.719 15.806 4.719ZM1.07812 10.9826V21.7066C1.07812 21.8357 1.18341 21.941 1.3125 21.941H1.36552C1.45927 20.4095 2.49436 19.132 3.89925 18.6798C3.34336 18.3139 2.97633 17.6843 2.97633 16.9692C2.97633 15.8393 3.89287 14.923 5.02275 14.923C6.15263 14.923 7.06917 15.8393 7.06917 16.9692C7.06917 17.6843 6.70219 18.3139 6.14625 18.6798C6.56628 18.8152 6.95832 19.0256 7.30341 19.3007V8.28084L1.22381 10.7657C1.13386 10.8024 1.07812 10.8854 1.07812 10.9826ZM6.12422 11.2463L2.32809 12.7924C2.31386 12.7983 2.29841 12.8005 2.2831 12.799C2.26779 12.7974 2.2531 12.7921 2.24033 12.7835C2.22756 12.775 2.21711 12.7633 2.2099 12.7498C2.20269 12.7362 2.19895 12.721 2.199 12.7056V11.607C2.199 11.5681 2.22136 11.5349 2.25741 11.5202L6.05353 9.97416C6.06776 9.9683 6.08322 9.96605 6.09853 9.9676C6.11384 9.96915 6.12853 9.97445 6.14129 9.98304C6.15406 9.99162 6.16452 10.0032 6.17173 10.0168C6.17894 10.0304 6.18268 10.0456 6.18262 10.061V11.1595C6.18283 11.1782 6.17736 11.1965 6.16693 11.212C6.1565 11.2275 6.1416 11.2395 6.12422 11.2463ZM9.13697 5.78691H14.863C14.9147 5.78691 14.9568 5.829 14.9568 5.88066V6.99417C14.9568 7.04583 14.9147 7.08792 14.863 7.08792H9.13697C9.08531 7.08792 9.04322 7.04583 9.04322 6.99417V5.88066C9.04322 5.82905 9.08531 5.78691 9.13697 5.78691ZM12.9249 11.8972H14.863C14.9147 11.8972 14.9568 11.9392 14.9568 11.9909V13.6532C14.9568 13.7049 14.9147 13.747 14.863 13.747H12.9249C12.8733 13.747 12.8312 13.7049 12.8312 13.6532V11.9909C12.8312 11.9393 12.8733 11.8972 12.9249 11.8972ZM9.13697 11.8972H11.0751C11.1267 11.8972 11.1688 11.9392 11.1688 11.9909V13.6532C11.1688 13.7049 11.1267 13.747 11.0751 13.747H9.13697C9.08531 13.747 9.04322 13.7049 9.04322 13.6532V11.9909C9.04322 11.9393 9.08531 11.8972 9.13697 11.8972ZM17.9465 9.97416L21.7426 11.5202C21.76 11.5271 21.7749 11.539 21.7854 11.5545C21.7958 11.5701 21.8013 11.5884 21.801 11.607V12.7056C21.8011 12.721 21.7974 12.7362 21.7901 12.7498C21.7829 12.7633 21.7725 12.775 21.7597 12.7835C21.7469 12.7921 21.7323 12.7974 21.7169 12.799C21.7016 12.8005 21.6862 12.7983 21.672 12.7924L17.8758 11.2463C17.8584 11.2395 17.8435 11.2275 17.8331 11.212C17.8227 11.1965 17.8172 11.1782 17.8174 11.1595V10.061C17.8174 10.0456 17.8211 10.0304 17.8283 10.0168C17.8355 10.0032 17.846 9.99162 17.8588 9.98304C17.8715 9.97445 17.8862 9.96915 17.9015 9.9676C17.9168 9.96605 17.9323 9.9683 17.9465 9.97416ZM12.9249 8.73075H14.863C14.9147 8.73075 14.9568 8.77284 14.9568 8.8245V10.4868C14.9568 10.5385 14.9147 10.5806 14.863 10.5806H12.9249C12.8733 10.5806 12.8312 10.5385 12.8312 10.4868V8.8245C12.8312 8.77284 12.8733 8.73075 12.9249 8.73075ZM9.13697 8.73075H11.0751C11.1267 8.73075 11.1688 8.77284 11.1688 8.8245V10.4868C11.1688 10.5385 11.1267 10.5806 11.0751 10.5806H9.13697C9.08531 10.5806 9.04322 10.5385 9.04322 10.4868V8.8245C9.04322 8.77284 9.08531 8.73075 9.13697 8.73075ZM16.6965 8.2808V19.2729C17.0417 18.9977 17.4338 18.7873 17.8539 18.6519C17.298 18.286 16.931 17.6564 16.931 16.9413C16.931 15.8114 17.8476 14.8951 18.9774 14.8951C20.1073 14.8951 21.0239 15.8114 21.0239 16.9413C21.0239 17.6564 20.6568 18.286 20.1009 18.6519C21.5143 19.1069 22.5531 20.3971 22.6359 21.941H22.6875C22.8166 21.941 22.9219 21.8357 22.9219 21.7066V10.9825C22.9219 10.8853 22.8661 10.8023 22.7762 10.7656L16.6965 8.2808Z'
        fill='#A8A8A8'
      />
    </svg>
  );
}
export function ProfileIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 50 50' fill='none'>
      <path
        d='M17.8572 19.6428C22.7883 19.6428 26.7857 15.6454 26.7857 10.7143C26.7857 5.78317 22.7883 1.78571 17.8572 1.78571C12.9261 1.78571 8.92859 5.78317 8.92859 10.7143C8.92859 15.6454 12.9261 19.6428 17.8572 19.6428Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.8571 44.6428H1.78571V42.7068C1.81414 39.9846 2.53205 37.3139 3.87238 34.9445C5.21274 32.575 7.13178 30.5839 9.45024 29.1571C11.7687 27.7304 14.411 26.9145 17.1303 26.7858C17.3727 26.7743 17.6151 26.7683 17.8571 26.7678C18.0992 26.7683 18.3416 26.7743 18.584 26.7858C21.3033 26.9145 23.9456 27.7304 26.2641 29.1571C27.5973 29.9776 28.7984 30.9846 29.8333 32.1429'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M48.2143 30.3571L33.9286 48.2143L26.7857 42.8571'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
export function SettingIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 52 52' fill='none'>
      <path
        d='M50.7347 12.9031C50.6602 12.4999 50.5016 12.1168 50.2689 11.7787C50.0362 11.4406 49.7348 11.1551 49.384 10.9407L41.6659 18.6366C41.3059 19.009 40.8745 19.3052 40.3971 19.5075C39.9197 19.7099 39.4061 19.8142 38.8874 19.8142C38.3688 19.8142 37.8555 19.7099 37.378 19.5075C36.9006 19.3052 36.469 19.009 36.1091 18.6366L33.1762 16.02C32.4691 15.3007 32.0731 14.3336 32.0731 13.3264C32.0731 12.3192 32.4691 11.3521 33.1762 10.6329L40.8941 2.93697C40.7259 2.5427 40.4727 2.19013 40.1528 1.90421C39.8325 1.61828 39.4536 1.40599 39.0418 1.28236C36.349 0.746879 33.5594 0.976094 30.9907 1.94391C28.422 2.91172 26.1774 4.57923 24.5125 6.75663C22.8476 8.93402 21.8293 11.5338 21.5735 14.26C21.3338 16.8137 21.7723 19.3822 22.8406 21.7088L2.13029 42.3594C0.601461 43.8839 0.626814 46.3632 2.1865 47.8562L4.35057 49.9279C5.85999 51.3728 8.24931 51.3551 9.73692 49.8875L30.685 29.2259C32.9507 30.159 35.4187 30.5139 37.8644 30.2524C40.5684 29.9634 43.1393 28.9321 45.2907 27.2732C47.4425 25.6143 49.0903 23.393 50.0512 20.856C51.0125 18.3191 51.2491 15.5661 50.7347 12.9031Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
export function BillingIcon({ height = 26, width = 26, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      {/* Euro outer curve */}
      <path
        d="M17 5.5C15.5 4 13.9 3.5 12 3.5C8.4 3.5 6 6.6 6 12C6 17.4 8.4 20.5 12 20.5C13.9 20.5 15.5 20 17 18.5"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Top horizontal bar */}
      <path
        d="M5 10H14"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Bottom horizontal bar */}
      <path
        d="M5 14H14"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function EventIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 52 52' fill='none'>
      <path d='M51 1H29.8461' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M51 13.5H29.8462' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M51 26H29.8462' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M51 51H29.8462' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M51 38.5H29.8462' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M1 3.08333V19.75C1 20.9006 1.86099 21.8333 2.92308 21.8333H18.3077C19.3698 21.8333 20.2308 20.9006 20.2308 19.75V3.08333C20.2308 1.93275 19.3698 1 18.3077 1H2.92308C1.86099 1 1 1.93275 1 3.08333Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 32.25V48.9167C1 50.0671 1.86099 51 2.92308 51H18.3077C19.3698 51 20.2308 50.0671 20.2308 48.9167V32.25C20.2308 31.0994 19.3698 30.1667 18.3077 30.1667H2.92308C1.86099 30.1667 1 31.0994 1 32.25Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export function InstructionsIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 52 52' fill='none'>
      <path
        d='M26 51C20.3664 44.7973 12.7262 40.7799 4.42315 39.6538C3.47807 39.5491 2.60523 39.098 1.97309 38.388C1.34094 37.6776 0.994305 36.7583 1.00007 35.8075V4.84572C1.00004 4.29018 1.12035 3.74121 1.35273 3.23659C1.58511 2.732 1.92405 2.28373 2.34622 1.92262C2.76096 1.56808 3.24638 1.30584 3.77027 1.15332C4.29411 1.0008 4.84446 0.961492 5.38469 1.038C13.3243 2.35573 20.5874 6.31258 26 12.2689V51Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26 51C31.6337 44.7973 39.2738 40.7799 47.5769 39.6538C48.5219 39.5491 49.395 39.098 50.0269 38.388C50.6592 37.6776 51.0057 36.7583 51 35.8075V4.84572C51 4.29018 50.8796 3.74121 50.6473 3.23659C50.415 2.732 50.0761 2.28373 49.6538 1.92262C49.2392 1.56808 48.7538 1.30584 48.23 1.15332C47.7057 1.0008 47.1557 0.961492 46.6154 1.038C38.6757 2.35573 31.4126 6.31258 26 12.2689V51Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
export function CalenderIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_69_173)'>
        <path
          d='M2.14287 2.85718C1.76398 2.85718 1.40062 3.00769 1.13271 3.27559C0.864804 3.54351 0.714294 3.90686 0.714294 4.28575V17.8572C0.714294 18.236 0.864804 18.5995 1.13271 18.8673C1.40062 19.1352 1.76398 19.2857 2.14287 19.2857H17.8572C18.236 19.2857 18.5994 19.1352 18.8673 18.8673C19.1352 18.5995 19.2857 18.236 19.2857 17.8572V4.28575C19.2857 3.90686 19.1352 3.54351 18.8673 3.27559C18.5994 3.00769 18.236 2.85718 17.8572 2.85718H15'
          stroke='#121212'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M0.714294 7.85718H19.2857' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M5 0.714294V5.00001' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M15 0.714294V5.00001' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M5 2.85718H12.1429' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_69_173'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function AddIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='25' height='26' viewBox='0 0 25 26' fill='none'>
      <g clip-path='url(#clip0_69_93)'>
        <path
          d='M12.5 24.6071C18.9105 24.6071 24.1071 19.4105 24.1071 13C24.1071 6.58952 18.9105 1.39282 12.5 1.39282C6.08952 1.39282 0.892822 6.58952 0.892822 13C0.892822 19.4105 6.08952 24.6071 12.5 24.6071Z'
          stroke='white'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M12.5 7.64282V18.3571' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M7.14282 13H17.8571' stroke='white' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_69_93'>
          <rect width='25' height='25' fill='white' transform='translate(0 0.5)' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function AttacIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_69_132)'>
        <path
          d='M8.57129 4.28566L10.6632 2.19356C12.6357 0.221124 15.8336 0.221124 17.8061 2.19356C19.7786 4.16602 19.7786 7.36398 17.8061 9.33643L15.7141 11.4285'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.4285 15.7143L9.33655 17.8064C7.36409 19.7788 4.16614 19.7788 2.19369 17.8064C0.221242 15.834 0.221243 12.636 2.19369 10.6635L4.28562 8.57141'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.8571 7.14282L7.14282 12.8571'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_69_132'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function AttacSmIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_69_98)'>
        <path
          d='M8.57129 4.28566L10.6632 2.19356C12.6357 0.221124 15.8336 0.221124 17.8061 2.19356C19.7786 4.16602 19.7786 7.36398 17.8061 9.33643L15.7141 11.4285'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.4285 15.7143L9.33655 17.8064C7.36409 19.7788 4.16614 19.7788 2.19369 17.8064C0.221242 15.834 0.221243 12.636 2.19369 10.6635L4.28562 8.57141'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.8571 7.14282L7.14282 12.8571'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_69_98'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
export function EditSmIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_69_103)'>
        <path
          d='M7.14293 17.4857L0.714355 19.2857L2.51436 12.8571L14.2858 1.14283C14.4188 1.00677 14.5778 0.898656 14.7531 0.824846C14.9285 0.751034 15.1169 0.713013 15.3072 0.713013C15.4975 0.713013 15.6859 0.751034 15.8614 0.824846C16.0366 0.898656 16.1956 1.00677 16.3286 1.14283L18.8572 3.68569C18.9911 3.81849 19.0974 3.9765 19.1699 4.15058C19.2425 4.32466 19.2798 4.51139 19.2798 4.69998C19.2798 4.88856 19.2425 5.07529 19.1699 5.24938C19.0974 5.42346 18.9911 5.58146 18.8572 5.71426L7.14293 17.4857Z'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_69_103'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function DeleteSmIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clip-path='url(#clip0_69_86)'>
        <path d='M1.42847 5H18.5713' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
        <path
          d='M3.57129 5H16.4284V17.8571C16.4284 18.236 16.2779 18.5994 16.01 18.8673C15.7421 19.1351 15.3787 19.2857 14.9999 19.2857H4.99986C4.62097 19.2857 4.25762 19.1351 3.9897 18.8673C3.7218 18.5994 3.57129 18.236 3.57129 17.8571V5Z'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.42847 4.99995V4.28566C6.42847 3.33846 6.80474 2.43005 7.47451 1.76028C8.14428 1.09051 9.0527 0.714233 9.9999 0.714233C10.9471 0.714233 11.8555 1.09051 12.5253 1.76028C13.1951 2.43005 13.5713 3.33846 13.5713 4.28566V4.99995'
          stroke='black'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M7.85693 9.28772V15.0042' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12.1428 9.28772V15.0042' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_69_86'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TaskIcon({ height, width, className }: IconProps) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M1.42864 4.28572C1.82313 4.28572 2.14293 3.96592 2.14293 3.57143C2.14293 3.17695 1.82313 2.85715 1.42864 2.85715C1.03415 2.85715 0.714355 3.17695 0.714355 3.57143C0.714355 3.96592 1.03415 4.28572 1.42864 4.28572Z'
        stroke='#121212'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M6.42871 3.57144H19.2859' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M1.42864 10.7143C1.82313 10.7143 2.14293 10.3945 2.14293 9.99999C2.14293 9.60551 1.82313 9.28571 1.42864 9.28571C1.03415 9.28571 0.714355 9.60551 0.714355 9.99999C0.714355 10.3945 1.03415 10.7143 1.42864 10.7143Z'
        stroke='#121212'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M6.42871 10H19.2859' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M1.42864 17.1429C1.82313 17.1429 2.14293 16.823 2.14293 16.4286C2.14293 16.0342 1.82313 15.7143 1.42864 15.7143C1.03415 15.7143 0.714355 16.0342 0.714355 16.4286C0.714355 16.823 1.03415 17.1429 1.42864 17.1429Z'
        stroke='#121212'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M6.42871 16.4286H19.2859' stroke='#121212' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
